import { render, staticRenderFns } from "./SRIntegralReport.vue?vue&type=template&id=fe5f28b2"
import script from "./SRIntegralReport.vue?vue&type=script&lang=js"
export * from "./SRIntegralReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe5f28b2')) {
      api.createRecord('fe5f28b2', component.options)
    } else {
      api.reload('fe5f28b2', component.options)
    }
    module.hot.accept("./SRIntegralReport.vue?vue&type=template&id=fe5f28b2", function () {
      api.rerender('fe5f28b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sfe/reportModule/SRIntegralReport.vue"
export default component.exports